import React from 'react';
import EInvoicingPortal from './EInvoicingPortal';
import { useAuthentication } from '../../hooks/useAuthentication';
import { UnAuthMain } from '../UnAuthMain';

const EInvoicingPortalContainer = (props) => {
  const { isAuthenticated } = useAuthentication();

  if (!isAuthenticated) {
    return <UnAuthMain {...props} />;
  }

  return <EInvoicingPortal {...props} />;
};

export default React.memo(EInvoicingPortalContainer);
